<!--
 * @Description: Message 页面专用布局 - 无侧边栏全宽布局
 * 移动端不显示 ToolHeader
-->
<template>
    <div class="message-layout">
        <!-- PC端显示 ToolHeader -->
        <ToolHeader class="tool-header" />
        <main class="message-main">
            <slot />
        </main>
        
        <!-- PWA 添加到桌面提示卡片（全局） -->
        <ClientOnly>
            <ToolPwaPromptCard />
        </ClientOnly>
    </div>
</template>

<script setup lang="ts">
import ToolHeader from '~/components/ToolHeader.vue'
import { usePwaPrompt } from '~/composables/usePwaPrompt'

const { initBeforeInstallPrompt, checkAndReportPwaTask } = usePwaPrompt()

// 初始化 PWA 相关功能
onMounted(() => {
    initBeforeInstallPrompt()
    checkAndReportPwaTask()
})
</script>

<style scoped lang="less">
.message-layout {
    display: flex;
    flex-direction: column;
    height: 100vh;
    overflow: hidden;
    background-color: var(--bg-default, #0f0f0f);
}

.tool-header {
    display: none;

    @media (min-width: 768px) {
        display: block;
    }
}

.message-main {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;
    overflow: hidden;
    padding-top: 0;

    @media (min-width: 768px) {
        padding-top: 52px; /* ToolHeader 高度 */
    }
}
</style>

